module.exports = __webpack_public_path__ + "img/difficulty-1-stars.ca5cdcce.png";